import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import imageCompression from 'browser-image-compression';

// molecules
import { ImgGallery } from '@components/molecules';

// material-ui
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button } from '@material-ui/core';

const DragNDrop = (props) => {
  const { type, uploadedImage, setUploadedImage, hasUploadedImage, setHasUploadedImage, dropZoneProps, changeImageClick, restrictFileExplorer, disableUpdateImage } = props;
  const onDrop = useCallback(
    (acceptedFiles) => {
      acceptedFiles.forEach(async(file) => {
        // console.log(`original file size ${file.size / 1024 / 1024} MB`);
        const maxSize = file.size > 10 ? 1 : 0.5;
        const options = {
          maxSizeMB: maxSize,
          maxWidthOrHeight: 1920,
          useWebWorker: true
        }
        try {
          file = await imageCompression(file, options);
        } catch (error) {
          console.log(error);
        }
        // console.log(`compressed file size ${file.size / 1024 / 1024} MB`);
        const reader = new FileReader();

        reader.onabort = () => console.log('file reading was aborted');
        reader.onerror = () => console.log('file reading has failed');
        reader.onload = () => {
          const base64 = reader.result;
          const images = [
            {
              original: base64,
            },
          ];
          setUploadedImage(images);
          typeof setHasUploadedImage === "function" && setHasUploadedImage(true);
        };

        reader.readAsDataURL(file);
      });
    },
    [setHasUploadedImage, setUploadedImage]
  );

  const { getRootProps, getInputProps, open } = useDropzone({ onDrop, ...dropZoneProps });

  const useStyles = makeStyles((theme) => ({
    uploadContainer: {
      padding: theme.spacing(3),
      borderStyle: 'dashed',
      cursor: 'pointer',
      opacity: props => props?.dropZoneProps?.disabled ? 0.4 : 1,
    },
    buttonContainer: {
      paddingBottom: theme.spacing(2),
    },
  }));

  const classes = useStyles(props);

  const changeImageClickHandler = () => {
    if (typeof changeImageClick === 'function') changeImageClick();
    if (restrictFileExplorer) return;
    open();
  };

  return (
    <>
      {!hasUploadedImage ? (
        <Box display='flex' justifyContent='center' {...getRootProps()}>
          <Box
            border={1}
            borderRadius='borderRadius'
            className={classes.uploadContainer}
          >
            <input {...getInputProps()} />
            <p>Drag 'n' drop, or click here to upload  image</p>
          </Box>
        </Box>
      ) : (
        <>
          <div className={classes.buttonContainer}>
            <Button onClick={changeImageClickHandler} variant="outlined" color="primary" disabled={disableUpdateImage}>Update Image</Button>
          </div>
          <ImgGallery showNav={false} images={uploadedImage} fullscreen={true} />
          <input {...getInputProps()} />
        </>
      )}
    </>
  );
};

DragNDrop.defaultProps = {
  dropZoneProps: {},
  changeImageClick: () => { },
  restrictFileExplorer: false,
  disableUpdateImage: false,
}

export default DragNDrop;
